var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMenuApt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6539 0.0625H12.2903C11.536 0.0625 10.9267 0.671875 10.9267 1.42614V8.24432H1.38121C0.626953 8.24432 0.0175781 8.85369 0.0175781 9.60795V28.6989C0.0175781 29.4531 0.626953 30.0625 1.38121 30.0625H28.6539C29.4082 30.0625 30.0176 29.4531 30.0176 28.6989V1.42614C30.0176 0.671875 29.4082 0.0625 28.6539 0.0625ZM2.74485 10.9716H10.9267V27.3352H2.74485V10.9716ZM27.2903 27.3352H13.6539V2.78977H27.2903V27.3352ZM24.563 8.24432H16.3812V5.51705H24.563V8.24432ZM24.563 13.6989H16.3812V10.9716H24.563V13.6989ZM24.563 19.1534H16.3812V16.4261H24.563V19.1534ZM24.563 24.608H16.3812V21.8807H24.563V24.608ZM5.47212 12.3352H8.1994V15.0625H5.47212V12.3352ZM5.47212 17.7898H8.1994V20.517H5.47212V17.7898ZM5.47212 23.2443H8.1994V25.9716H5.47212V23.2443Z",
    fill: "#240b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuApt);
export default __webpack_public_path__ + "static/media/new-menu-apt.7764bd8eccea20a43d55b5568e91f306.svg";
export { ForwardRef as ReactComponent };